import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { from, race } from 'rxjs';
import { defaultIfEmpty, map, switchMap, take } from 'rxjs/operators';
import { currentEncounterId, isEmptyEncounterId } from '@mona/pdms/data-access-combined';
import { isSameEncounterFilter } from '@mona/shared/utils';
import { makeDefaultAsyncActionEffect } from '@mona/store';
import { PreMedicationsState } from '../../entities';
import { PreMedicationsApi } from '../../infrastructure';
import { PreMedicationsAction } from '../actions';

/**
 * Pre medications effects
 */
@Injectable()
export class PreMedicationsEffects {
    /* Effect Declarations */

    /**
     * Load pre medications effect
     */

    loadPreMedications$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PreMedicationsAction.loadPreMedicationsAction.action),
            switchMap(action =>
                race(
                    isEmptyEncounterId(this.store).pipe(
                        take(1),
                        map(() => PreMedicationsAction.loadPreMedicationsAction.clearAction()),
                    ),
                    from(
                        makeDefaultAsyncActionEffect(
                            this.preMedicationsApi
                                .getPreMedications(action.encounterId)
                                .pipe(isSameEncounterFilter(currentEncounterId(this.store), action.encounterId)),
                            PreMedicationsAction.loadPreMedicationsAction,
                        ),
                    ).pipe(defaultIfEmpty(PreMedicationsAction.loadPreMedicationsAction.clearAction())),
                ),
            ),
        ),
    );

    /**
     * Constructor
     *
     * @param actions$ Actions
     * @param preMedicationsApi PreMedicationsApi
     * @param store Store<PreMedicationsState>
     */
    constructor(
        private actions$: Actions,
        private preMedicationsApi: PreMedicationsApi,
        private store: Store<PreMedicationsState>,
    ) {}
}
